import { getPrivateApi } from "../lib/axiosConfig";
import { CarWashingResponse, WashingVehicle } from "../types/carWashing.types";
import { AppError } from "./classes";

const api = getPrivateApi();
const endpoint = "/car-washings"

export const getCarWashings = async (station: string): Promise<WashingVehicle[]> => {

  try {
    const { data } = await api.get<CarWashingResponse[]>(`${endpoint}/station/${station}`)

    return data.map((item) => {
      const { fleets, clients } = item.info;
      const fleet = fleets[0];
      const client = clients[0];

      const status = item.info.statuses?.find((s) => s !== null) ?? null;

      return {
        ...item.carWashing,
        clientName: fleet?.client?.name ?? client?.name,
        fleetDescription: fleet?.description,
        status,
      };
    });
  } catch (error: any) {
    const errMsg = "Erro ao buscar lista de veículos";

    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    
    throw new AppError(message, error.status);
  };
};

export const getAllCarWashings = async (): Promise<WashingVehicle[]> => {

  try {
    const { data: vehicleList } = await api.get(`${endpoint}`)
    return vehicleList;;
  }
  catch (error: any) {
    const errMsg = "Erro ao buscar lista de veículos";
    console.error(errMsg, error?.response ?? error);
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error.status);
  };
}

export const resetCarWashing = async (id: string): Promise<void> => {
  try {
    await api.put(`${endpoint}/reset/${id}`);
  } catch (error: any) {
    const errMsg = "Erro ao resetar máquina";
    console.error(errMsg, error?.response ?? error);
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error.status);
  };
};

export const createCarWashing = async (payload: any): Promise<void> => {
  try {
    await api.post(`${endpoint}`, payload);
  } catch (error: any) {
    const errMsg = "Erro ao criar máquina";
    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error.status);
  }
};

export const deleteCarWashing = async (id: string): Promise<void> => {
  try {
    await api.delete(`${endpoint}/${id}`);
  } catch (error: any) {
    const errMsg = "Erro ao deletar máquina";
    console.error(errMsg, error?.response ?? error);
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error.status);
  }
};
